"use client";

import { motion } from "motion/react";
import Image from "next/image";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import ZeekMapsIcon from "../ui/icons/ZeekMapsIcon";
import {
	ArrowBlack1Icon,
	ArrowBlack2Icon,
	ArrowGreenLeftIcon,
	ArrowGreenRightIcon,
} from "../ui/icons/icons";

export const CommunityHero = () => {
	return (
		<div className="p-12 bg-[#0038FF] dark:bg-[#0a1630] flex flex-col font-sans selection:bg-[#CCFF00] selection:text-black relative overflow-hidden w-full">
			{/* Background Grid */}
			<div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff15_1px,transparent_1px),linear-gradient(to_bottom,#ffffff15_1px,transparent_1px)] bg-[size:4rem_4rem] pointer-events-none z-0" />

			{/* Logo */}
			<div className="mt-6 w-full flex flex-col items-center justify-center gap-1">
				<ZeekMapsIcon className="w-24 h-auto" />
				<div className="flex gap-1">
					<div className="bg-white text-black font-black tracking-tight text-xs md:text-sm px-3 py-1.5 rounded-2xl rounded-bl-sm relative shadow-sm">
						YOUR
						<div
							className="absolute -bottom-1.5 left-0 w-3 h-3 bg-white"
							style={{ clipPath: "polygon(0 0, 100% 0, 0 100%)" }}
						/>
					</div>
					<div className="bg-[#CCFF00] text-black font-black text-xs md:text-sm px-3 py-1.5 rounded-full border-[1.5px] border-white shadow-sm">
						MAP
					</div>
				</div>
			</div>

			{/* Hero Section */}
			<main className="flex-1 relative z-10 pt-8 pb-32 md:pt-12 md:pb-48 px-4 flex flex-col items-center justify-center w-full max-w-[1440px] mx-auto">
				{/* Massive Typography & Elements Container */}
				<div className="relative w-full max-w-5xl mx-auto flex flex-col items-center justify-center text-center z-10 mt-4 mb-16">
					{/* Text Stack */}
					<div className="w-full flex flex-col items-center relative z-10 space-y-2 md:space-y-4">
						{/* Your */}
						<div className="w-full flex justify-center relative z-20">
							<h1
								className="text-[clamp(5rem,15vw,220px)] font-black leading-[0.85] tracking-tighter text-white dark:text-white/80 m-0 p-0 uppercase"
								style={{
									fontFamily: '"Arial Black", Impact, sans-serif',
									textShadow:
										"1px 1px 0 #001A99, 2px 2px 0 #001A99, 3px 3px 0 #001A99, 4px 4px 0 #001A99, 5px 5px 0 #001A99, 6px 6px 0 #001A99, 7px 7px 0 #001A99, 8px 8px 0 #001A99, 9px 9px 0 #001A99, 10px 10px 0 #001A99, 11px 11px 0 #001A99, 12px 12px 0 #001A99, 13px 13px 0 #001A99, 14px 14px 0 #001A99",
								}}
							>
								YOUR
							</h1>
						</div>

						{/* #CLUB */}
						<div className="w-full flex justify-start pl-[10%] md:pl-[25%] relative z-30">
							<h1
								className="text-[clamp(3rem,8vw,160px)] md:text-[clamp(5rem,8vw,160px)] lg:text-[clamp(4.5rem,12vw,160px)] font-black leading-[0.85] tracking-tighter text-[#CCFF00] m-0 p-0 uppercase"
								style={{
									fontFamily: '"Arial Black", Impact, sans-serif',
									textShadow:
										"1px 1px 0 #001A99, 2px 2px 0 #001A99, 3px 3px 0 #001A99, 4px 4px 0 #001A99, 5px 5px 0 #001A99, 6px 6px 0 #001A99, 7px 7px 0 #001A99, 8px 8px 0 #001A99, 9px 9px 0 #001A99, 10px 10px 0 #001A99, 11px 11px 0 #001A99, 12px 12px 0 #001A99, 13px 13px 0 #001A99, 14px 14px 0 #001A99",
								}}
							>
								#MAPCLUB
							</h1>
						</div>

						{/* SOCIALFI */}
						<div className="w-full flex justify-center relative z-20">
							<h1
								className="text-[clamp(3rem,8vw,160px)] md:text-[clamp(5rem,8vw,160px)] lg:text-[clamp(5rem,15vw,220px)] font-black leading-[0.85] tracking-tighter text-white m-0 p-0 uppercase"
								style={{
									fontFamily: '"Arial Black", Impact, sans-serif',
									textShadow:
										"1px 1px 0 #001A99, 2px 2px 0 #001A99, 3px 3px 0 #001A99, 4px 4px 0 #001A99, 5px 5px 0 #001A99, 6px 6px 0 #001A99, 7px 7px 0 #001A99, 8px 8px 0 #001A99, 9px 9px 0 #001A99, 10px 10px 0 #001A99, 11px 11px 0 #001A99, 12px 12px 0 #001A99, 13px 13px 0 #001A99, 14px 14px 0 #001A99",
								}}
							>
								COMMUNITY
							</h1>
						</div>

						{/* PEOPLE */}
						<div className="w-full flex justify-start pl-[15%] md:pl-[30%] relative z-10">
							<h1
								className="text-[clamp(3rem,8vw,160px)] lg:text-[clamp(4.5rem,12vw,160px)] font-black leading-[0.85] tracking-tighter text-white dark:text-white/80 m-0 p-0 uppercase"
								style={{
									fontFamily: '"Arial Black", Impact, sans-serif',
									textShadow:
										"1px 1px 0 #001A99, 2px 2px 0 #001A99, 3px 3px 0 #001A99, 4px 4px 0 #001A99, 5px 5px 0 #001A99, 6px 6px 0 #001A99, 7px 7px 0 #001A99, 8px 8px 0 #001A99, 9px 9px 0 #001A99, 10px 10px 0 #001A99, 11px 11px 0 #001A99, 12px 12px 0 #001A99, 13px 13px 0 #001A99, 14px 14px 0 #001A99",
								}}
							>
								&amp; PEOPLE
							</h1>
						</div>
					</div>

					{/* Absolute Overlays (Cards, Arrows, Badge) */}
					<div className="absolute inset-0 w-full h-full pointer-events-none">
						{/* Floating Glass Card 1 (Bottom Left) */}
						<motion.div
							animate={{ y: [0, -15, 0] }}
							transition={{
								duration: 5,
								repeat: Number.POSITIVE_INFINITY,
								ease: "easeInOut",
							}}
							className="absolute bottom-[-90%] left-[50%] md:bottom-[-50%] md:left-[20%] lg:bottom-[-20%] lg:left-[20%] z-30 pointer-events-auto"
						>
							<div className="w-26 lg:w-32 aspect-[3/3.5] bg-white/20 backdrop-blur-md border border-white/40 rounded-[2rem] p-5 flex flex-col items-center justify-center rotate-[-12deg] shadow-2xl hover:rotate-0 transition-transform duration-500">
								<Avatar className="border-2 w-16 lg:w-24 h-auto">
									<AvatarImage
										src="/images/profiles/demo-users/arnab.jpg"
										alt="Arnab, Community Member"
										className="object-cover"
									/>
									<AvatarFallback>ARN</AvatarFallback>
								</Avatar>
								<div className="text-center mt-2">
									<p className="font-bold text-sm md:text-lg text-white">
										arnab
									</p>
									<p className="text-[10px] md:text-xs text-white/80 mt-1">
										23 422 Karma
									</p>
								</div>
							</div>
						</motion.div>

						{/* Floating Glass Card 2 (Top Right) */}
						<motion.div
							animate={{ y: [0, -20, 0] }}
							transition={{
								duration: 6,
								repeat: Number.POSITIVE_INFINITY,
								ease: "easeInOut",
								delay: 1,
							}}
							className="absolute top-[-80%] right-[0%] md:top-[-40%] md:right-[5%] lg:top-[-10%] lg:right-[-5%] z-30 pointer-events-auto"
						>
							<div className="w-26 lg:w-32 aspect-[3/3.5] bg-white/20 backdrop-blur-md border border-white/40 rounded-[2rem] p-5 flex flex-col items-center justify-center rotate-[12deg] shadow-2xl hover:rotate-0 transition-transform duration-500">
								<Avatar className="border-2 w-16 lg:w-24 h-auto">
									<AvatarImage
										src="/images/profiles/demo-users/artyom.jpg"
										alt="Artyom, Community Member"
										className="object-cover"
									/>
									<AvatarFallback>ART</AvatarFallback>
								</Avatar>
								<div className="text-center mt-2">
									<p className="font-bold text-sm md:text-lg text-white">
										artyom
									</p>
									<p className="text-[10px] md:text-xs text-white/80 mt-1">
										293 582 Karma
									</p>
								</div>
							</div>
						</motion.div>

						{/* Floating Glass Card 3 (Top Left) */}
						<motion.div
							animate={{ y: [0, -20, 0] }}
							transition={{
								duration: 6,
								repeat: Number.POSITIVE_INFINITY,
								ease: "easeInOut",
								delay: 1,
							}}
							className="absolute top-[-80%] left-[5%] md:top-[-20%] md:left-[10%] lg:top-[10%] lg:left-[2%] z-30 pointer-events-auto"
						>
							<div className="w-26 lg:w-32 aspect-[3/3.5] bg-white/20 backdrop-blur-md border border-white/40 rounded-[2rem] p-5 flex flex-col items-center justify-center rotate-[-12deg] shadow-2xl hover:rotate-0 transition-transform duration-500">
								<Avatar className="border-2 w-16 lg:w-24 h-auto">
									<AvatarImage
										src="/images/profiles/demo-users/angus.jpg"
										alt="Angus, Community Member"
										className="object-cover"
									/>
									<AvatarFallback>ANG</AvatarFallback>
								</Avatar>
								<div className="text-center mt-2">
									<p className="font-bold text-sm md:text-lg text-white">
										angus
									</p>
									<p className="text-[10px] md:text-xs text-white/80 mt-1">
										421 001 Karma
									</p>
								</div>
							</div>
						</motion.div>

						{/* Decorative Arrow Left */}
						<div className="absolute bottom-[0%] left-[0%] md:left-[10%] w-12 h-12 md:w-24 md:h-24 lg:w-32 lg:h-32 z-20">
							<ArrowGreenLeftIcon />
						</div>

						{/* Decorative Arrow Right */}
						<div className="absolute top-[5%] right-[0%] md:right-[10%] w-12 h-12 md:w-24 md:h-24 lg:w-32 lg:h-32 z-20">
							<ArrowGreenRightIcon />
						</div>

						{/* Circular Badge */}
						<div className="absolute bottom-[-10%] right-[0%] md:right-[15%] z-40 pointer-events-auto">
							<CircularBadge />
						</div>
					</div>
				</div>
			</main>

			{/* Bottom Features Section */}
			<section className="max-w-5xl mx-auto bg-background text-black rounded-[3.5rem] p-6 relative z-20 shadow-[0_-20px_50px_rgba(0,0,0,0.2)] mt-auto w-full">
				<div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
					{/* Card 1 */}
					<div className="bg-[#F8F9FA] dark:bg-white/20 rounded-[2rem] p-6 flex flex-col items-center text-center relative border border-primary">
						<h3 className="text-lg lg:text-2xl text-primary uppercase leading-tight mb-2 font-black">
							SUBSCRIBE
							<br />
							<span className="text-primary/50">TO MAPS</span>
						</h3>
						<p className="text-[10px] md:text-xs text-primary/60 font-bold">
							you will receive your $KARMA on every interaction
						</p>

						{/* Pill Graphic */}
						<div className="relative w-full flex justify-center mt-6">
							<div className="flex items-center bg-[#0038FF] rounded-2xl p-2 pr-16 text-white shadow-lg relative z-10">
								<div className="w-8 h-8 bg-[#D2B48C] rounded-full mr-3 border border-white/30 overflow-hidden flex-shrink-0">
									<Image
										src="/images/profiles/users/3.jpg"
										alt="Avatar"
										width={32}
										height={32}
										className="w-full h-full object-cover"
									/>
								</div>
								<div className="text-left">
									<p className="text-[10px] font-bold leading-none">
										nyc.social
									</p>
									<p className="text-[8px] text-white/70 leading-none mt-1">
										23 422 points
									</p>
								</div>
							</div>
							<div className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#CCFF00] text-black font-black text-[10px] px-3 py-2 rounded-xl z-20 shadow-md">
								20.24 $KARMA
							</div>
						</div>

						{/* Arrow pointing to next card */}
						<div className="hidden md:block absolute -right-12 bottom-8 w-16 h-16 z-30">
							<ArrowBlack1Icon />
						</div>
					</div>

					{/* Card 2 */}
					<div className="bg-[#F8F9FA] dark:bg-white/20 rounded-[2rem] p-6 flex flex-col items-center text-center relative border border-primary">
						<h3 className="text-lg lg:text-2xl text-primary uppercase leading-tight mb-2 font-black">
							Buy or sell
							<br />
							<span className="text-primary/50">$KARMA</span>
						</h3>
						<p className="text-[10px] md:text-xs text-primary/60 font-bold">
							buy or sell $KARMA to others for exclusive access
						</p>

						{/* Pill Graphic */}
						<div className="relative w-full flex justify-center mt-6">
							<div className="flex items-center bg-[#0038FF] rounded-full p-1.5 text-white shadow-lg">
								<div className="bg-white/20 text-white font-bold text-sm px-4 py-2 rounded-full mr-2">
									20.4220
								</div>
								<div className="font-bold text-xs px-4">$KARMA</div>
							</div>

							{/* Small floating green pill */}
							<div className="absolute -bottom-6 right-1/3 bg-[#CCFF00] rounded-full p-2.5 shadow-lg transform rotate-12 z-20">
								<svg
									viewBox="0 0 24 24"
									className="w-4 h-4 text-black stroke-current"
									fill="none"
									strokeWidth="3"
									strokeLinecap="round"
									strokeLinejoin="round"
									aria-hidden="true"
								>
									<path d="M7 17L17 7M17 7H7M17 7V17" />
								</svg>
							</div>
						</div>

						{/* Arrow pointing to next card */}
						<div className="hidden md:block absolute -right-12 bottom-8 w-16 h-16 z-30">
							<ArrowBlack2Icon />
						</div>
					</div>

					{/* Card 3 */}
					<div className="bg-[#F8F9FA] dark:bg-white/20 rounded-[2rem] p-6 flex flex-col items-center text-center relative border border-primary">
						<h3 className="text-lg lg:text-2xl text-primary uppercase leading-tight mb-2 font-black">
							UNLOCK <br /> <span className="text-primary/50">HIDDEN MAPS</span>
						</h3>
						<p className="text-[10px] md:text-xs text-primary/60 font-bold">
							use $KARMA to unlock hidden maps
						</p>

						{/* Pill Graphic */}
						<div className="flex flex-col items-center bg-[#CCFF00] rounded-[2rem] p-2 text-black shadow-lg mt-6 relative w-full max-w-[200px]">
							<p className="text-[9px] font-bold uppercase tracking-wider mb-1">
								Your $KARMA
							</p>
							<p className="text-xl font-black">188.34257</p>

							{/* Speech bubble tail */}
							<div className="absolute -bottom-2 left-8 w-5 h-5 bg-[#CCFF00] transform rotate-45" />
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

const CircularBadge = () => (
	<div className="relative w-14 h-14 md:w-28 md:h-28 lg:w-36 lg:h-36 bg-[#CCFF00]/80 rounded-full flex items-center justify-center shadow-xl rotate-12 hover:scale-105 transition-transform cursor-pointer border-[3px] border-black/5">
		<div className="absolute inset-1 animate-[spin_10s_linear_infinite]">
			<svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden="true">
				<path
					id="circlePath"
					d="M 50, 50 m -36, 0 a 36,36 0 1,1 72,0 a 36,36 0 1,1 -72,0"
					fill="none"
				/>
				<text
					className="text-[11px] font-black tracking-[0.18em] uppercase"
					fill="black"
				>
					<textPath href="#circlePath" startOffset="0%">
						GET STARTED OF FREE • GET STARTED OF FREE •
					</textPath>
				</text>
			</svg>
		</div>
		<div className="absolute inset-0 flex items-center justify-center">
			<svg
				viewBox="0 0 100 100"
				className="w-5 h-5 md:w-10 md:h-10 text-black stroke-current overflow-visible"
				fill="none"
				strokeWidth="8"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M20,80 Q 40,50 30,30 T 80,20" />
				<path d="M60,10 L80,20 L70,40" />
			</svg>
		</div>
	</div>
);
